export default __webpack_public_path__ + "static/media/GroovyGravity_09.ce3265e5.png";